import TmLogo from "@assets/tm_logo.webp";
import WelcomeBg from "@assets/tm90/welcome_bg.png";
import { ReactElement } from "react";

// WelcomeBanner Component
const WelcomeBanner = (): ReactElement => {
  return (
    <div className="m-auto max-w-[1280px]">
      <div
        className="bg-orange-600 pb-12 pt-2 md:pt-5 min-h-[420px] text-center items-center justify-center bg-no-repeat bg-bottom bg-cover"
        style={{ backgroundImage: `url('${WelcomeBg}')` }}
      >
        <div className="max-w-6xl mx-auto px-4 mb-24 pb-16">
          <img
            width={297.5}
            height={68}
            alt="Home"
            src={TmLogo}
            className="inline py-3 w-[180px] md:w-[298px]"
          />
          <div className="text-2sm md:text-2md font-bold text-left leading-7 text-red-900 max-w-[800px] m-auto">
            <div className="pb-2">
              முரசோ கம்பீரமான ஒலியுடையது. வயிரம் பாய்ந்த நெஞ்சுடையது; இரக்கமான
              சித்தமுடையது; எடுத்த காரியம் யாவினும் வெற்றிபெறும் திடமுடையது.
            </div>
            <div className="text-right text-xs font-bold leading-5 text-red-950">
              தமிழவேள் கோ சாரங்கபாணி
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
